var AccessibleViewProviderId;
( (function(AccessibleViewProviderId) {
    AccessibleViewProviderId["Terminal"] = "terminal";
    AccessibleViewProviderId["TerminalChat"] = "terminal-chat";
    AccessibleViewProviderId["TerminalHelp"] = "terminal-help";
    AccessibleViewProviderId["DiffEditor"] = "diffEditor";
    AccessibleViewProviderId["Chat"] = "panelChat";
    AccessibleViewProviderId["InlineChat"] = "inlineChat";
    AccessibleViewProviderId["InlineCompletions"] = "inlineCompletions";
    AccessibleViewProviderId["KeybindingsEditor"] = "keybindingsEditor";
    AccessibleViewProviderId["Notebook"] = "notebook";
    AccessibleViewProviderId["Editor"] = "editor";
    AccessibleViewProviderId["Hover"] = "hover";
    AccessibleViewProviderId["Notification"] = "notification";
    AccessibleViewProviderId["EmptyEditorHint"] = "emptyEditorHint";
    AccessibleViewProviderId["Comments"] = "comments";
})(AccessibleViewProviderId || (AccessibleViewProviderId = {})));
var AccessibleViewType;
( (function(AccessibleViewType) {
    AccessibleViewType["Help"] = "help";
    AccessibleViewType["View"] = "view";
})(AccessibleViewType || (AccessibleViewType = {})));
var NavigationType;
( (function(NavigationType) {
    NavigationType["Previous"] = "previous";
    NavigationType["Next"] = "next";
})(NavigationType || (NavigationType = {})));
class AdvancedContentProvider {
    constructor(id, options, provideContent, onClose, verbositySettingKey, onOpen, actions, next, previous, onDidChangeContent, onKeyDown, getSymbols, onDidRequestClearLastProvider) {
        this.id = id;
        this.options = options;
        this.provideContent = provideContent;
        this.onClose = onClose;
        this.verbositySettingKey = verbositySettingKey;
        this.onOpen = onOpen;
        this.actions = actions;
        this.next = next;
        this.previous = previous;
        this.onDidChangeContent = onDidChangeContent;
        this.onKeyDown = onKeyDown;
        this.getSymbols = getSymbols;
        this.onDidRequestClearLastProvider = onDidRequestClearLastProvider;
    }
}
class ExtensionContentProvider {
    constructor(id, options, provideContent, onClose, onOpen, next, previous, actions, onDidChangeContent) {
        this.id = id;
        this.options = options;
        this.provideContent = provideContent;
        this.onClose = onClose;
        this.onOpen = onOpen;
        this.next = next;
        this.previous = previous;
        this.actions = actions;
        this.onDidChangeContent = onDidChangeContent;
    }
}
export { AccessibleViewProviderId, AccessibleViewType, AdvancedContentProvider, ExtensionContentProvider, NavigationType };
